import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext, useEffect } from 'react';
import { viewBaseEvent } from '@chegg-me-components/utils';
import { rioClient } from '../../rio';
import { HeaderContext, isNavLinkItem, useDesktopCenterNavBehaviour } from '../../shared';
import { CenterNavList, CenterNavListItem } from '../../styles/desktop';
import CenterNavLink from './desktopCenterNavLink';
import FlyOutMenu from './desktopFlyOutMenu';

var CenterNav = function CenterNav(_ref) {
  var navLinks = _ref.navLinks,
      activeLink = _ref.activeLink;
  useEffect(function () {
    rioClient.sendEvent(_objectSpread(_objectSpread({}, viewBaseEvent), {}, {
      data: {
        component_view: {
          component: {
            name: 'nav bar',
            type: 'component',
            region_name: 'top nav',
            text: navLinks.map(function (navItem) {
              return isNavLinkItem(navItem) ? navItem.text : navItem.parent.text;
            }).join('|').toLowerCase()
          }
        }
      }
    }));
  }, []);

  var _useContext = useContext(HeaderContext),
      dataTestPrefix = _useContext.dataTestPrefix;

  var _useDesktopCenterNavB = useDesktopCenterNavBehaviour(),
      activeNavItem = _useDesktopCenterNavB.activeNavItem,
      getActiveNavItem = _useDesktopCenterNavB.getActiveNavItem,
      setActiveNavItem = _useDesktopCenterNavB.setActiveNavItem,
      flyOutHoverOutDelayTimer = _useDesktopCenterNavB.flyOutHoverOutDelayTimer;

  return /*#__PURE__*/React.createElement("nav", {
    role: "navigation",
    "aria-label": "main",
    "data-test": "".concat(dataTestPrefix, "-center-nav")
  }, /*#__PURE__*/React.createElement(CenterNavList, {
    "data-test": "".concat(dataTestPrefix, "-center-nav-list")
  }, navLinks.map(function (navItem, index) {
    return /*#__PURE__*/React.createElement(CenterNavListItem, {
      key: index,
      "data-test": "".concat(dataTestPrefix, "-center-nav-list-item-").concat(index)
    }, isNavLinkItem(navItem) ? /*#__PURE__*/React.createElement(CenterNavLink, {
      index: index,
      navLink: navItem,
      isActive: activeNavItem === index,
      setActiveNavItem: setActiveNavItem,
      activeLink: activeLink,
      flyOutHoverOutDelayTimer: flyOutHoverOutDelayTimer
    }) : /*#__PURE__*/React.createElement(FlyOutMenu, {
      index: index,
      isActive: activeNavItem === index,
      setActiveNavItem: setActiveNavItem,
      getActiveNavItem: getActiveNavItem,
      navMenu: navItem,
      activeLink: activeLink,
      flyOutHoverOutDelayTimer: flyOutHoverOutDelayTimer
    }));
  })));
};

CenterNav.displayName = 'DesktopCenterNav';
export default CenterNav;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/signed-out-header/dist/esm/components/desktop/desktopCenterNav.js
// module id = 5629
// module chunks = 11